module.exports = __webpack_public_path__ + "fonts/cdd505f4dfc8eb501fc97decc6f40c13.svg";